import { SDK, ServerOptions } from '@commercetools/frontend-sdk';
import { AcceptedQueryTypes } from '@commercetools/frontend-sdk/lib/types/Query';
import { ComposableCommerceEventsB2B } from '../../types/events/ComposableCommerceEventsB2B';
import {
  CreditNoteActions,
  DownloadCreditNoteDocActionReturn,
  GetCreditNotesTabActionReturn,
  GetCreditNotesTabQuery,
} from '../../types/actions/CreditNoteActions';

export type { CreditNoteActions };

export const getCreditNoteActions = (sdk: SDK<ComposableCommerceEventsB2B>): CreditNoteActions => ({
  getCreditNotesTab: async (
    query?: GetCreditNotesTabQuery,
    options: {
      parallel?: boolean;
      customHeaderValue?: string;
      serverOptions?: ServerOptions;
    } = {},
  ) => {
    const response = await sdk.callAction<GetCreditNotesTabActionReturn>({
      actionName: 'creditNotes/getCreditNotesTab',
      query: query as AcceptedQueryTypes | undefined,
      parallel: options.parallel,
      customHeaderValue: options.customHeaderValue,
      serverOptions: options.serverOptions,
    });
    return response;
  },

  downloadCreditNoteDoc: async (creditNoteReference: string, options = {}) => {
    const response = await sdk.callAction<DownloadCreditNoteDocActionReturn>({
      actionName: 'creditNotes/downloadCreditNoteDoc',
      query: { creditNoteReference },
      serverOptions: options.serverOptions,
    });
    return response;
  },
});
